<template>
  <j-modal
    :maskClosable="false"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="1200"
    @cancel="handleCancel"
    @ok="handleOk"
    switchFullscreen
  >
    <dev-maintenance-stl-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm" />
  </j-modal>
</template>

<script>

  import DevMaintenanceStlForm from './DevMaintenanceStlForm'

  export default {
    name: 'DevMaintenanceStlModal',
    components: {
      DevMaintenanceStlForm
    },
    data () {
      return {
        title: '',
        width: 600,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>


</style>